import Navigo from 'navigo';

class Router {
    constructor(notFoundComponent) {
        this._notFound = notFoundComponent;

        // Yeah, the root building is kinda awful, but it does not work without it ...
        this.nav = new Navigo(`${location.protocol}//${location.host}`, false);

        // Register not found handler
        this.nav.notFound(() => this.showNotFound());
    }

    showNotFound() {
        if (!this._notFound) {
            return console.warn('No notFoundComponent registered!');
        }

        new this._notFound({
            target: document.body
        });
    }

    addRoute(path, component, params, additional) {
        if ((typeof path !== 'string' && !(path instanceof RegExp)) || !component) return false;

        let routeHandler = (function(path, component, params, additional) {
            return (q) => {
                let props = typeof additional === 'object' ? additional : {};
                if (Array.isArray(params)) {
                    for (let param of params) {
                        if (!q || !q.hasOwnProperty(param)) continue;

                        props[param] = q[param];
                    }
                }

                new component({
                    target: document.body,
                    props
                });
            }
        })(path, component, params, additional);

        if (path) {
            this.nav.on(path, routeHandler);
        } else {
            this.nav.on(routeHandler);
        }

        return true;
    }

    addRedirect(path, cb) {
        let routeHandler = (function(path, cb) {
            return (...args) => {
                let newLoc = cb(...args);

                if (newLoc) location.href = newLoc;
            }
        })(path, cb);

        this.nav.on(path, routeHandler);

        return true;
    }

    resolve() {
        return this.nav.resolve();
    }
}

export default Router;